<template>
    <div class="set-with-draw">
        <div class="panle now-count-info">
            <span class="tit">
                *提现前请先设置以下信息，填写错误导致的任何问题，本公司概不负责。请谨慎填写！
            </span>
            <div class="count-info">
                <div class="item name">
                    <span class="item-name">姓名:</span>
                    <input type="text" v-model="name" placeholder="请填写真实姓名" />
                </div>
                <div class="item phone">
                    <span class="item-name">手机号:</span>
                    <input type="text" v-if="(dataInfo.username=='')||(dataInfo.username==null)" v-model="phone" placeholder="请填写正确的手机号" />
                    <span class="phone" v-if="(dataInfo.username!=null)">{{phone}}</span>
                </div>
                <div class="item idcard">
                    <span class="item-name">身份证:</span>
                    <input type="text" v-model="idCard" placeholder="请填写正确的身份证" />
                </div>
                <div class="item card">
                    <span class="item-name">银行卡:</span>
                    <input type="text" v-model="card" placeholder="请填写正确的银行卡号" />
                </div>
                <div class="item bank">
                    <span class="item-name">开户银行:</span>
                    <input type="text" v-model="bank" placeholder="请填写正确的开户银行" />
                </div>
                <div class="item code">
                    <span class="item-name">验证码:</span>
                    <input type="text" v-model="code" placeholder="请填写验证码" />
                    <span class="get-code" v-if="!isGetCode" @click="getCode">立即获取</span>
                    <span class="sendCode" v-if="isGetCode">{{time+' s'}}</span>
                </div>
            </div>
            <div class="save-info">
                <button @click="save">保存</button>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {BASE_URL,API_BASE_URL} from "./../../../../urlConfig/index";
    export default{
        props:['curStoreId', 'pageSize'],
        data () {
            return {
                name:"",
                idCard:"",
                card:"",
                bank:"",
                isShowCodeTip:false, // 是否显示验证嘛提示
                isGetCode:false, // 是否获取验证码
                time:60,
                phone:'', // 手机号
                code: '', // 验证码
                info:[],
                dataInfo:{}
            }
        },
        methods: {
            getCode: function () {
                this.phone = this.phone.replace(/\s+/g, "");
                if ( (/^1[3|4|5|6|7|8|9][0-9]{9}$/).test(this.phone) ) {
                    this.isGetCode = true;
                    this.$http.post(API_BASE_URL+'v1/verify-code?mobile='+this.phone+'&type=ACCOUNT').then((res)=>{
                        this.isShowCodeTip = true;
                        let intervalCode = setInterval(()=>{
                            this.time--;
                            if ( this.time <= 0 ) {
                                this.isGetCode = false;
                                this.isShowCodeTip = false;
                                this.time = 60;
                                clearInterval(intervalCode);
                            }
                        }, 1000);
                    }).catch((err)=>{
                        this.isGetCode = false;
                        this.isShowCodeTip = false;
                    })
                } else {
                    this.$message({
                        message: '请输入正确的手机号',
                        customClass: 'error'
                    });
                    return;                   
                }
            },
            save(){
                if(!this.phone||!this.name||!this.bank||!this.code||!this.idCard||!this.card){
                    this.$message({
                        message: '请完整填写信息',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !(/^1[3|4|5|6|7|8|9][0-9]{9}$/).test(this.phone) ) {
                    this.$message({
                        message: '手机号格式不正确',
                        customClass: 'error'
                    })
                    return;
                }
                this.$http({
                    url:"update-account",
                    method:"POST",
                    data:{
                         username:this.phone,
                         name:this.name,
                         accountPayee:this.card,
                         verCode:this.code,
                         bankName:this.bank,
                         accountPeople:this.name,
                         storeId:this.curStoreId,
                         cdCard:this.idCard
                    }
                }).then(res=>{
                    console.log(res);
                    if(res.data.result.code == 200){
                        this.$message({
                            message: res.data.result.msg,
                            customClass: 'success'
                        });
                    }else if(res.data.result.code == 400){
                        this.$message({
                            message: res.data.result.msg,
                            customClass: 'error'
                        });
                    }
                });
            },
            getInfo(){
               this.$http({
                    url:"get-account",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    let data = res.data;
                    this.dataInfo = data;
                    this.name = data.name;
                    this.idCard = data.cdCard;
                    this.card = data.accountPayee;
                    this.bank = data.bankName;
                    this.phone = data.username;
                })
            }
        },
        mounted: function () {
            this.getInfo();
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "./setWithdraw.scss";
</style>



// WEBPACK FOOTER //
// setWithdraw.vue?51ea97e6